import React from 'react';
import { Link } from 'react-router-dom';
import { latestNews } from '../data/dummyData';
import './LatestNews.css';

const LatestNews = () => {
  return (
    <aside className="latest-news">
      <div className="news-header">
        <h2 className="news-title">Latest Updates</h2>
        <p className="news-subtitle">Stay informed with the latest education news</p>
        <div className="news-indicator"></div>
      </div>
      
      {/* Breaking News Banner */}
      {/* <div className="breaking-news">
        <span>BREAKING</span>
        <span>New CBC updates released for 2024 academic year</span>
      </div> */}
      
      <div className="news-list">
        {latestNews.map((news) => (
          <article key={news.id} className="news-card">
            <div className="news-card-image">
              <img src={news.image} alt={news.title} />
              <div className="image-overlay">
                {/* <span className="news-category">{news.category}</span> */}
              </div>
            </div>
            
            <div className="news-card-content">
              <div className="news-card-header">
                <span className="news-category">{news.category}</span>
                <time className="news-date" dateTime={news.date}>
                  {new Date(news.date).toLocaleDateString('en-US', {
                    month: 'long',
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </time>
              </div>
              
              <h3 className="news-card-title">{news.title}</h3>
              <p className="news-excerpt">{news.excerpt}</p>
              
              <Link 
                to={`/news/${news.id}`} 
                className="news-read-more"
                state={{ news }}
              >
                Read Full Story
              </Link>
            </div>
          </article>
        ))}
      </div>
      
      
    </aside>
  );
};

export default LatestNews;